import API from '../api/api'
import {_exportDownloadLinkDecorator, parseItemId} from '../helper'
import cloneDeep from 'lodash/cloneDeep';
import { t } from 'i18next';

const SYNC_PRODUCTS_PENDING = 'SYNC_PRODUCTS_PENDING'
const SYNC_PRODUCTS_PROGRESS = 'SYNC_PRODUCTS_PROGRESS'
const SYNC_PRODUCTS_RESPONSE = 'SYNC_PRODUCTS_RESPONSE'
const SYNC_PRODUCTS_BATCH = 'SYNC_PRODUCTS_BATCH'
const SYNC_PRODUCT_PENDING = 'SYNC_PRODUCT_PENDING'
const SYNC_PRODUCT_RESPONSE = 'SYNC_PRODUCT_RESPONSE'
const GET_OPTION_VALUES_PAGE_PENDING = 'GET_OPTION_VALUES_PAGE_PENDING'
const GET_OPTION_VALUES_PAGE_RESPONSE = 'GET_OPTION_VALUES_PAGE_RESPONSE'
const GET_OPTION_VALUES_CACHED_PAGE = 'GET_OPTION_VALUES_CACHED_PAGE'
const SAVE_PRODUCTS_PENDING = 'SAVE_PRODUCTS_PENDING'
const SAVE_PRODUCTS_PROGRESS = 'SAVE_PRODUCTS_PROGRESS'
const SAVE_PRODUCTS_RESPONSE = 'SAVE_PRODUCTS_RESPONSE'
const SAVE_PRODUCTS_ABORTED = 'SAVE_PRODUCTS_ABORTED'
const RESAVE_PRODUCTS_PENDING = 'RESAVE_PRODUCTS_PENDING'
const RESAVE_PRODUCTS_PROGRESS = 'RESAVE_PRODUCTS_PROGRESS'
const RESAVE_PRODUCTS_RESPONSE = 'RESAVE_PRODUCTS_RESPONSE'
const SAVE_METADATA_PENDING = 'SAVE_METADATA_PENDING'
const SAVE_METADATA_PROGRESS = 'SAVE_METADATA_PROGRESS'
const SAVE_METADATA_RESPONSE = 'SAVE_METADATA_RESPONSE'
const SAVE_METADATA_ABORTED = 'SAVE_METADATA_ABORTED'
const SYNC_PRODUCT_METAFIELDS_PENDING = 'SYNC_PRODUCT_METAFIELDS_PENDING'
const SYNC_PRODUCT_METAFIELDS_PROGRESS = 'SYNC_PRODUCT_METAFIELDS_PROGRESS'
const SYNC_PRODUCT_METAFIELDS_RESPONSE = 'SYNC_PRODUCT_METAFIELDS_RESPONSE'
const SYNC_PRODUCT_METAFIELDS_ABORTED = 'SYNC_PRODUCT_METAFIELDS_ABORTED'
const SYNC_PRODUCT_VARIANT_METAFIELDS_PENDING = 'SYNC_PRODUCT_VARIANT_METAFIELDS_PENDING'
const SYNC_PRODUCT_VARIANT_METAFIELDS_PROGRESS = 'SYNC_PRODUCT_VARIANT_METAFIELDS_PROGRESS'
const SYNC_PRODUCT_VARIANT_METAFIELDS_RESPONSE = 'SYNC_PRODUCT_VARIANT_METAFIELDS_RESPONSE'
const SYNC_PRODUCT_VARIANT_METAFIELDS_ABORTED = 'SYNC_PRODUCT_VARIANT_METAFIELDS_ABORTED'
const SYNC_PRODUCT_IMAGES_PENDING = 'SYNC_PRODUCT_IMAGES_PENDING'
const SYNC_PRODUCT_IMAGES_PROGRESS = 'SYNC_PRODUCT_IMAGES_PROGRESS'
const SYNC_PRODUCT_IMAGES_RESPONSE = 'SYNC_PRODUCT_IMAGES_RESPONSE'
const SYNC_PRODUCT_IMAGES_ABORTED = 'SYNC_PRODUCT_IMAGES_ABORTED'
const CREATE_PRODUCT_CUSTOM_CONTENTS_PENDING = 'CREATE_PRODUCT_CUSTOM_CONTENTS_PENDING'
const CREATE_PRODUCT_CUSTOM_CONTENTS_PROGRESS = 'CREATE_PRODUCT_CUSTOM_CONTENTS_PROGRESS'
const CREATE_PRODUCT_CUSTOM_CONTENTS_RESPONSE = 'CREATE_PRODUCT_CUSTOM_CONTENTS_RESPONSE'
const DELETE_PRODUCT_CUSTOM_CONTENT_PENDING = 'DELETE_PRODUCT_CUSTOM_CONTENT_PENDING'
const DELETE_PRODUCT_CUSTOM_CONTENT_PROGRESS = 'DELETE_PRODUCT_CUSTOM_CONTENT_PROGRESS'
const DELETE_PRODUCT_CUSTOM_CONTENT_RESPONSE = 'DELETE_PRODUCT_CUSTOM_CONTENT_RESPONSE'
const EXPORT_PRODUCTS_PENDING = 'EXPORT_PRODUCTS_PENDING'
const EXPORT_PRODUCTS_PROGRESS = 'EXPORT_PRODUCTS_PROGRESS'
const EXPORT_PRODUCTS_RESPONSE = 'EXPORT_PRODUCTS_RESPONSE'
const IMPORT_PRODUCTS_PENDING = 'IMPORT_PRODUCTS_PENDING'
const IMPORT_PRODUCTS_PROGRESS = 'IMPORT_PRODUCTS_PROGRESS'
const IMPORT_PRODUCTS_RESPONSE = 'IMPORT_PRODUCTS_RESPONSE'
const RESET_ERRORS = 'RESET_ERRORS'
const CLEAR_EXPORT_URLS = 'CLEAR_EXPORT_URLS'

const initialState = {
  sync_products_pending: true,
  sync_synced_count: null,
  sync_total_count: null,
  sync_product_pending: false,
  sync_product_metafields_pending: false,
  sync_product_variant_metafields_pending: false,
  sync_product_images_pending: false,
  create_product_custom_contents_pending: false,
  delete_product_custom_content_pending: false,
  save_products_pending: false,
  save_metadata_pending: false,
  export_products_pending: false,
  export_po_download_url: null,
  export_csv_download_url: null,
  export_advanced_csv_download_url: null,
  import_products_pending: false,
  get_option_values_page_pending: false,
  imported_entries: 0,
  progress: 0,
  error: false,
  saveErrors: [],
  products: [],
  tags: [],
  types: [],
  vendors: [],
}

function validateProduct(data, origin) {
  if (typeof data.general_errors !== 'undefined' && typeof data.general_errors.errors !== 'undefined') {
    data.general_errors.errors.forEach(item => {
      switch(item.object_key) {
        case 'handle' :
          //data.target.handle = origin.target.handle;
          break;
      }
    })
  }
  return data;
}
function overwritePaginatedArray(bigArray, pageNumber, newEntries) {
  const itemsPerPage = 100;
  const startIndex = (pageNumber - 1) * itemsPerPage;

  //if (startIndex >= bigArray.length || startIndex < 0) {
  //    throw new Error("Invalid page number");
  //}

  // Überschreiben der Einträge im großen Array
  for (let i = 0; i < newEntries.length && i < itemsPerPage; i++) {
      bigArray[startIndex + i] = newEntries[i];
  }

  return bigArray;
}

// REDUCER
export default (state = initialState, action) => {
  switch(action.type) {
    case RESET_ERRORS: {
      return {
        ...state,
        error: false,
        saveErrors: [],
      }
    }

    case SYNC_PRODUCTS_PENDING: {
      return {
        ...state,
        products: [],
        tags: [],
        types: [],
        vendors: [],
        progress: 0,
        sync_synced_count: null,
        sync_total_count: null,
        sync_products_pending: true,
        export_products_pending: false,
        export_po_download_url: null,
        export_csv_download_url: null,
        export_advanced_csv_download_url: null,
        error: false,
      }
    }
    case SYNC_PRODUCTS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress,
        sync_synced_count: action.syncedCount ?? state.sync_synced_count,
        sync_total_count: action.totalCount ?? state.sync_total_count
      }
    }
    case SYNC_PRODUCTS_BATCH: {
      // sync/batch liefert die kumulative Produktliste, daher nur noch unbekannte ids anhängen
      const existingIds = new Set(state.products.map(product => product.id))
      const newProducts = action.products.filter(product => !existingIds.has(product.id))

      if(newProducts.length === 0) {
        return state
      }

      return {
        ...state,
        products: [...state.products, ...newProducts]
      }
    }
    case SYNC_PRODUCTS_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          sync_products_pending: false,
          error: false,
          products: action.response.products,
          tags: action.response.tags,
          types: action.response.types,
          vendors: action.response.vendors
        }
      } else {
        return {
          ...state,
          sync_products_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 0,
          },
        }
      }
    }
    
    case SYNC_PRODUCT_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_product_pending: true,
        error: false,
      }
    }
    case SYNC_PRODUCT_RESPONSE: {
      if(action.response.success === true) {
        let newProducts = state.products.slice()
        let productToUpdate = newProducts.find(x => x.id == action.response.product.id)
        
        productToUpdate.synchronized = true;

        productToUpdate.progress = action.response.product.progress

        productToUpdate.source = {
          title: action.response.product.source.title,
          body_html: action.response.product.source.body_html,
          product_type: action.response.product.source.product_type,
          handle: action.response.product.source.handle,
          page_title: action.response.product.source.page_title,
          page_description: action.response.product.source.page_description
        }

        productToUpdate.target = {
          title: action.response.product.target.title,
          body_html: action.response.product.target.body_html,
          product_type: action.response.product.target.product_type,
          handle: action.response.product.target.handle,
          page_title: action.response.product.target.page_title,
          page_description: action.response.product.target.page_description
        }
        
        //productToUpdate.options = action.response.product.options.slice();
        productToUpdate.options = overwritePaginatedArray(Array(action.response.product.option_values_count_total).fill(null), 1, action.response.product.options.slice());
        productToUpdate.optionsLoadedPages = [1];
        productToUpdate.optionsTotal = action.response.product.option_values_count_total;
        productToUpdate.optionsCurrentPage = productToUpdate.optionsCurrentPage || 1;
        
        productToUpdate.optionNames = action.response.product.option_names.slice()
        productToUpdate.custom_contents = action.response.product.custom_contents.slice()
        productToUpdate.customSeo = action.response.product.custom_seo

        return {
          ...state,
          products: newProducts,
          sync_product_pending: false,
          error: false,
        }
      } else {
        return {
          ...state,
          sync_product_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 1,
          },
        }
      }
    }


    case GET_OPTION_VALUES_PAGE_PENDING: {
      return {
        ...state,
        get_option_values_page_pending: true,
        error: false,
      }
    }
    case GET_OPTION_VALUES_PAGE_RESPONSE: {
      //debugger;
      if(action.response.success === true) {
        let newProducts = state.products.slice()
        let productToUpdate = newProducts.find(x => x.id == action.productId)
        
        //if(productToUpdate.optionsLoadedPages?.includes())
        productToUpdate.options = overwritePaginatedArray(productToUpdate.options.slice(), action.page, action.response.result.options.slice());
        productToUpdate.optionsLoadedPages.push(action.page);
        productToUpdate.optionsCurrentPage = action.page;

        return {
          ...state,
          get_option_values_page_pending: false,
          products: newProducts,
          error: false
        }
      } else {
        return {
          ...state,
          get_option_values_page_pending: false,
          error: {
            message: action.response,
            action: action.action,
          },
        }
      }
    }
    case GET_OPTION_VALUES_CACHED_PAGE: {
      let newProducts = state.products.slice()
      let productToUpdate = newProducts.find(x => x.id == action.productId)
      productToUpdate.optionsCurrentPage = action.page;
      return {
        ...state,
        products: newProducts,
      }
    }


    case SAVE_PRODUCTS_PENDING: {
      return {
        ...state,
        progress: 0,
        save_products_pending: true,
        error: false,
      }
    }
    case SAVE_PRODUCTS_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    case SAVE_PRODUCTS_RESPONSE: {
      // The response echoes what was written for the language the save was issued for. The
      // abort races a response already on the wire, so it can still land after the merchant
      // selected another language - merging it then is what puts one language's text under another.
      if(action.stale === true) {
        return {
          ...state,
          save_products_pending: false,
          error: false,
        }
      }

      let newProducts = state.products.slice();
      let error = false;
      let saveErrors = [];

      //console.log(action.response)
      //debugger;

      if(Array.isArray(action.response)) {
        action.response.forEach((response, i) => {

          if(response.status === 'fulfilled') {
            if(response.value.success !== true) {
              error = {
                message: action.response,
                action: action.action,
              };
            } else {
              let newProduct = newProducts.find(x => x.id == response.value.product.id);
              let product = validateProduct(response.value.product,newProduct);
              newProduct.progress = product.progress;
              // commented out so source is not overwritten if backend returns insufficient data
              // newProduct.source = {...product.source};
              newProduct.target = {...product.target};

              

              newProduct.options = product.options.slice();
              //newProduct.options = newProduct.options;
              //newProduct.optionsCurrentPage = newProduct.optionsCurrentPage;

              newProduct.optionNames = product.option_names.slice();
              newProduct.metafields = product.metafields.slice();
              newProduct.images = product.images.slice();
              newProduct.custom_contents = product.custom_contents.slice();
              newProduct.errors = product.general_errors.errors;
  
              // Save Errors
              // TODO: Remove error object mapping when api returns equally structured errors
              if(response.value.product.metafield_errors && response.value.product.metafield_errors.length > 0) {
                let newErrors = cloneDeep(response.value.product.metafield_errors);
                newErrors.forEach((error) => {
                  error.validation_errors = {
                    [error.errors.error_tag]: error.errors.message
                  };
                  delete error.errors;
                  error.object_subfieldsId = 'metafields';
                  error.object_key = error.metafield_langifyId;
                  error.object_langifyId = error.metafield_langifyId; delete error.metafield_langifyId;
                  error.object_ownerType = error.metafield_ownerType; delete error.metafield_ownerType;
                  error.object_shopifyId = error.metafield_shopifyId; delete error.metafield_shopifyId;
                  error.object_type = error.metafield_type; delete error.metafield_type;
                })
                saveErrors.push({
                  object: parseItemId(newProduct.id),
                  errors: newErrors
                });
                //console.log('Loop'+i+' :', saveErrors);
              }
            }
  
          
          }
        })

      } else {

        //console.log(action.response)
      }

      //console.log('Out of Loop :', saveErrors);

      return {
        ...state,
        products: newProducts,
        save_products_pending: false,
        error: error,
        saveErrors: saveErrors,
      }
    }

    // A save dropped because the merchant left the language never answers, and nothing refires
    // it the way a switch refires the sync - so the flag it set is cleared here. Both save paths
    // share the flag, so they share the case. Not an error: the merchant asked for it.
    case SAVE_PRODUCTS_ABORTED: {
      return {
        ...state,
        progress: 0,
        save_products_pending: false,
        error: false,
      }
    }
    case RESAVE_PRODUCTS_PENDING: {
      return {
        ...state,
        progress: 0,
        save_products_pending: true,
        error: false,
      }
    }
    case RESAVE_PRODUCTS_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    case RESAVE_PRODUCTS_RESPONSE: {
      return {
        ...state,
        save_products_pending: false,
        error: false
      }
    }

    case SAVE_METADATA_PENDING: {
      return {
        ...state,
        progress: 0,
        save_metadata_pending: true,
        error: false,
      }
    }
    case SAVE_METADATA_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    // A save dropped because the merchant left the language never answers, and nothing refires
    // it - so the flag it set is cleared here. Not an error: the merchant asked for it.
    case SAVE_METADATA_ABORTED: {
      return {
        ...state,
        progress: 0,
        save_metadata_pending: false,
        error: false,
      }
    }
    case SAVE_METADATA_RESPONSE: {
      // The response echoes what was written for the language the save was issued for. The
      // abort races a response already on the wire, so it can still land after the merchant
      // selected another language - applying it then is what puts one language's text under another.
      if(action.stale === true) {
        return {
          ...state,
          save_metadata_pending: false,
          error: false,
        }
      }

      let isOk = true;
      let newTags = state.tags.slice();
      let newTypes = state.types.slice();
      let newVendors = state.vendors.slice();
      action.response.forEach(response => {
        if(response.success !== true) {
          isOk = false;
        } else {
          response.items.forEach(item => {
            if(item.type === 'tags') {
              newTags.find(x => x.id == item.id).target = item.target
            } else if(item.type === 'types') {
              newTypes.find(x => x.id == item.id).target = item.target
            } else if(item.type === 'vendors') {
              newVendors.find(x => x.id == item.id).target = item.target
            }
          })
        }
      })
      if(isOk === true) {
        return {
          ...state,
          tags: newTags,
          types: newTypes,
          vendors: newVendors,
          save_metadata_pending: false,
          error: false
        }
      } else {
        return {
          ...state,
          save_metadata_pending: false,
          error: {
            message: action.response,
            action: action.action,
          },
        }
      }
      return {
        ...state
      }
    }
    case SYNC_PRODUCT_METAFIELDS_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_product_metafields_pending: true
      }
    }
    case SYNC_PRODUCT_METAFIELDS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_PRODUCT_METAFIELDS_ABORTED: {
      return {
        ...state,
        sync_product_metafields_pending: false,
        error: false,
      }
    }
    case SYNC_PRODUCT_METAFIELDS_RESPONSE: {
      // A row sync answers for the language it was issued in; landing after a switch it would
      // stamp that language's fields on the row now on screen and mark it as synced.
      if(action.stale === true) {
        return {
          ...state,
          sync_product_metafields_pending: false,
        }
      }
      if(action.response.success === true) {
        let newProducts = state.products.slice()
        let productToUpdate = newProducts.find(x => x.id == action.response.product_id)
        if(!productToUpdate) {
          return { ...state, sync_product_metafields_pending: false }
        }
        
        productToUpdate.metafields_synchronized = true;
        productToUpdate.metafields = action.response.metafields.slice()

        return {
          ...state,
          sync_product_metafields_pending: false,
          products: newProducts,
          error: false
        }
      } else {
        return {
          ...state,
          sync_product_metafields_pending: false,
          error: {
            message: action.response,
            action: action.action,
          },
        }
      }
      return {
        ...state,
        sync_product_metafields_pending: false
      }
    }
    case SYNC_PRODUCT_VARIANT_METAFIELDS_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_product_variant_metafields_pending: true
      }
    }
    case SYNC_PRODUCT_VARIANT_METAFIELDS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_PRODUCT_VARIANT_METAFIELDS_ABORTED: {
      return {
        ...state,
        sync_product_variant_metafields_pending: false,
        error: false,
      }
    }
    case SYNC_PRODUCT_VARIANT_METAFIELDS_RESPONSE: {
      // A row sync answers for the language it was issued in; landing after a switch it would
      // stamp that language's fields on the row now on screen and mark it as synced.
      if(action.stale === true) {
        return {
          ...state,
          sync_product_variant_metafields_pending: false,
        }
      }
      if(action.response.success === true) {
        let newProducts = state.products.slice()
        let productToUpdate = newProducts.find(x => x.id == action.response.product_id)
        if(!productToUpdate) {
          return { ...state, sync_product_variant_metafields_pending: false }
        }
        
        productToUpdate.variant_metafields_synchronized = true;
        productToUpdate.variant_metafields = action.response.variant_metafields.slice()

        return {
          ...state,
          sync_product_variant_metafields_pending: false,
          products: newProducts,
          error: false
        }
      } else {
        return {
          ...state,
          sync_product_variant_metafields_pending: false,
          error: {
            message: action.response,
            action: action.action,
          },
        }
      }
      return {
        ...state,
        sync_product_variant_metafields_pending: false
      }
    }
    case SYNC_PRODUCT_IMAGES_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_product_images_pending: true,
        error: false,
      }
    }
    case SYNC_PRODUCT_IMAGES_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_PRODUCT_IMAGES_ABORTED: {
      return {
        ...state,
        sync_product_images_pending: false,
        error: false,
      }
    }
    case SYNC_PRODUCT_IMAGES_RESPONSE: {
      // A row sync answers for the language it was issued in; landing after a switch it would
      // stamp that language's fields on the row now on screen and mark it as synced.
      if(action.stale === true) {
        return {
          ...state,
          sync_product_images_pending: false,
        }
      }
      if(action.response.success === true) {
        let newProducts = state.products.slice()
        let productToUpdate = newProducts.find(x => x.id == action.response.product_id)
        if(!productToUpdate) {
          return { ...state, sync_product_images_pending: false }
        }
        
        productToUpdate.images_synchronized = true;
        productToUpdate.images = action.response.images.slice()

        return {
          ...state,
          sync_product_images_pending: false,
          products: newProducts,
          error: false
        }
      } else {
        return {
          ...state,
          sync_product_images_pending: false,
          error: {
            message: action.response.message || 'An unexpected error occurred.',
            action: action.action,
            level: 3
          },
        }
      }
      return {
        ...state,
        sync_product_images_pending: false
      }
    }
    case CREATE_PRODUCT_CUSTOM_CONTENTS_PENDING: {
      return {
        ...state,
        create_product_custom_contents_pending: true,
        error: false,
      }
    }
    case CREATE_PRODUCT_CUSTOM_CONTENTS_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    case CREATE_PRODUCT_CUSTOM_CONTENTS_RESPONSE: {
      let newProducts = state.products.slice()
      let error = false;

      for(let i in action.response) {
        const response = action.response[i];
        if(response.success !== true) {
          error = {
            message: action.response,
            action: action.action,
          };
        } else {
          let productToUpdate = newProducts.find(x => x.id == response.product_id)
          productToUpdate.custom_contents.push({
            id: response.custom_content.id,
            source: {
              text: response.custom_content.source.text
            },
            target: {
              text: response.custom_content.target.text
            }
          });
        }
      }

      return {
        ...state,
        products: newProducts,
        create_product_custom_contents_pending: false,
        error: error
      }
    }
    case DELETE_PRODUCT_CUSTOM_CONTENT_PENDING: {
      return {
        ...state,
        delete_product_custom_content_pending: true,
        error: false,
      }
    }
    case DELETE_PRODUCT_CUSTOM_CONTENT_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    case DELETE_PRODUCT_CUSTOM_CONTENT_RESPONSE: {
      let newProducts = state.products.slice()
      let error = false;

      if(action.response.success !== true) {
          error = {
            message: action.response,
            action: action.action,
          };
      } else {
        let productToUpdate = newProducts.find(x => x.id == action.response.product_id)
        productToUpdate.custom_contents = productToUpdate.custom_contents.filter(x => x.id != action.response.id)
      }

      return {
        ...state,
        products: newProducts,
        delete_product_custom_content_pending: false,
        error: error
      }
    }
    case EXPORT_PRODUCTS_PENDING: {
      return {
        ...state,
        progress: 0,
        export_products_pending: true,
        error: false,
        export_po_download_url: null,
        export_csv_download_url: null,
        export_advanced_csv_download_url: null
      }
    }
    case EXPORT_PRODUCTS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case EXPORT_PRODUCTS_RESPONSE: {
      if(action.response.success == true) {
        return {
          ...state,
          progress: 100,
          export_products_pending: false,
          export_po_download_url: _exportDownloadLinkDecorator(action.response.po_download_url, action.options),
          export_csv_download_url: _exportDownloadLinkDecorator(action.response.csv_download_url, action.options),
          export_advanced_csv_download_url: _exportDownloadLinkDecorator(action.response.advanced_csv_download_url, action.options)
        }
      } else {
        return {
          ...state,
          progress: 100,
          export_products_pending: false,
          // a snackbar, the full-page error would stay hidden behind the open export dialog
          error: {
            message: action.response.code === 'OPERATION_IN_PROGRESS' ? t('exportFeature.otherExportsInProgress') : (action.response.message || action.response),
            action: action.action,
            level: 3,
          },
        }
      }
    }
    case IMPORT_PRODUCTS_PENDING: {
      return {
        ...state,
        progress: 0,
        import_products_pending: true,
        import_cancelled: false,
        imported_entries: 0,
        error: false
      }
    }
    case IMPORT_PRODUCTS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case IMPORT_PRODUCTS_RESPONSE: {
      // the merchant cancelled after reviewing the file, nothing was imported
      if(action.response && action.response.cancelled === true) {
        return {
          ...state,
          progress: 0,
          import_products_pending: false,
          import_cancelled: true
        }
      }
      if(action.response.success == true) {
        return {
          ...state,
          progress: 100,
          import_products_pending: false,
          imported_entries: action.response.num_imported_entries
        }
      } else {
        return {
          ...state,
          progress: 100,
          import_products_pending: false,
          error: {
            message: action.response.message || action.response,
            action: action.action,
          },
        }
      }
    }
    case CLEAR_EXPORT_URLS: {
      return {
        ...state,
        progress: 0,
        export_products_pending: false,
        export_advanced_csv_download_url: null,
        export_csv_download_url: null,
        export_po_download_url: null,
      }
    }
    default:
      return state
  }
}

// ACTIONS
export const resetErrors = () => {
  return dispatch => {
    dispatch({
      type: RESET_ERRORS
    });
  }
}
export const syncProducts = (language, sync_reset, callback, options = {}) => {
  return dispatch => {
    // A held sync is the bulk tool's own work: it runs and answers its callback,
    // but nothing of it reaches the store
    const mirror = (action) => {
      if(options.held !== true) {
        dispatch(action);
      }
    }
    mirror({
      type: SYNC_PRODUCTS_PENDING
    })

    API.syncProducts(
      language,
      (progress, syncedCount, totalCount) => {
        mirror({
          type: SYNC_PRODUCTS_PROGRESS,
          progress: progress,
          syncedCount: syncedCount,
          totalCount: totalCount
        })
      },
      products => {
        mirror({
          type: SYNC_PRODUCTS_BATCH,
          products: products
        })
      },
      response => {
        // A dropped sync is not dispatched at all: the switch that dropped it has already
        // started the sync for the language now on screen, and that one owns the pending flag.
        // Dispatching would either replace the list with an empty result or, on the else
        // branch, put up an error dialog for something the merchant asked for.
        if(response && response.aborted === true) {
          // The answer is dropped, but the callback still fires: callers use it to resolve a
          // promise, and one that never hears back leaves the ui waiting for good.
          if(callback) {
            callback(response);
          }
          return;
        }

        mirror({
          type: SYNC_PRODUCTS_RESPONSE,
          response: response,
          action: () => syncProducts(language, sync_reset, callback)
        });
        if(callback) {
          callback(response);
        }
      },
      sync_reset,
      options
    )
  }
}

export const resyncProducts = (language) => {
  return dispatch => {
    dispatch({
      type: SYNC_PRODUCTS_PENDING
    })

    API.resyncProducts(
      language,
      (progress, syncedCount, totalCount) => {
        dispatch({
          type: SYNC_PRODUCTS_PROGRESS,
          progress: progress,
          syncedCount: syncedCount,
          totalCount: totalCount
        })
      },
      products => {
        dispatch({
          type: SYNC_PRODUCTS_BATCH,
          products: products
        })
      },
      response => {
        if(response && response.aborted === true) {
          return;
        }

        dispatch({
          type: SYNC_PRODUCTS_RESPONSE,
          response: response,
          action: () => resyncProducts(language)
        })
      }
    )
  }
}

export const syncProduct = (productId, languageId) => {  
  return dispatch => {
    dispatch({
      type: SYNC_PRODUCT_PENDING
    })

    API.syncProduct(
      productId,
      languageId,
      response => {
        dispatch({
          type: SYNC_PRODUCT_RESPONSE,
          response: response,
          action: () => syncProduct(productId, languageId)
        })
      }
    )
  }
}

export const saveProducts = (language, items, force = 0) => {  
  return (dispatch, getState) => {
    dispatch({
      type: SAVE_PRODUCTS_PENDING
    })

    API.saveProducts(
      language,
      items,
      force,
      progress => {
        dispatch({
          type: SAVE_PRODUCTS_PROGRESS,
          progress: progress
        })
      },
      response => {
        if(response && response.aborted === true) {
          dispatch({
            type: SAVE_PRODUCTS_ABORTED
          })
          return;
        }

        dispatch({
          type: SAVE_PRODUCTS_RESPONSE,
          response: response,
          items: items,
          stale: getState().shop.shop.edit_language !== language,
          action: () => saveProducts(language, items, force)
        })
      })
  }
}

export const resaveProducts = (language, items) => {  
  return dispatch => {
    dispatch({
      type: RESAVE_PRODUCTS_PENDING
    })

    API.resaveProducts(
      language,
      items,
      progress => {
        dispatch({
          type: RESAVE_PRODUCTS_PROGRESS,
          progress: progress
        })
      },
      response => {
        if(response && response.aborted === true) {
          dispatch({
            type: SAVE_PRODUCTS_ABORTED
          })
          return;
        }

        dispatch({
          type: RESAVE_PRODUCTS_RESPONSE,
          response: response,
          items: items,
          action: () => resaveProducts(language, items)
        })
      })
  }
}

export const saveMetadata = (language, tags, types, vendors, force = 0) => {  
  return (dispatch, getState) => {
    dispatch({
      type: SAVE_METADATA_PENDING
    })

    API.saveProductsMetadata(
      language,
      tags,
      types,
      vendors,
      force,
      progress => {
        dispatch({
          type: SAVE_METADATA_PROGRESS,
          progress: progress
        })
      },
      response => {
        if(response && response.aborted === true) {
          dispatch({
            type: SAVE_METADATA_ABORTED
          })
          return;
        }

        dispatch({
          type: SAVE_METADATA_RESPONSE,
          response: response,
          stale: getState().shop.shop.edit_language !== language,
          action: () => saveMetadata(language, tags, types, vendors, force)
        })
      })
  }
}

export const syncProductMetafields = (product, language) => {  
  return (dispatch, getState) => {
    dispatch({
      type: SYNC_PRODUCT_METAFIELDS_PENDING
    })

    API.syncProductMetafields(
      product,
      language,
      progress => {
        dispatch({
          type: SYNC_PRODUCT_METAFIELDS_PROGRESS,
          progress: progress
        })
      },
      response => {
        // Nothing refires a row sync after a switch, so the dropped one clears its own flag
        if(response && response.aborted === true) {
          dispatch({
            type: SYNC_PRODUCT_METAFIELDS_ABORTED
          })
          return;
        }

        dispatch({
          type: SYNC_PRODUCT_METAFIELDS_RESPONSE,
          response: response,
          stale: getState().shop.shop.edit_language !== language,
          action: () => syncProductMetafields(product, language)
        }
      )
    })
  }
}

export const getProductOptionValuesPaginated = (productId, languageId, page) => {


  return (dispatch, getState)  => {

    /*
    const state = getState(); // Access the current state
    let targetProduct = state.products.products.find(x => x.id === productId);
    console.log(targetProduct);
    if(targetProduct.optionsLoadedPages && targetProduct.optionsLoadedPages.includes(page)) {
      dispatch({
        type: GET_OPTION_VALUES_CACHED_PAGE,
        productId: productId,
        page: page,
      })
    }
    */


    dispatch({
      type: GET_OPTION_VALUES_PAGE_PENDING
    })
    API.getProductOptionValuesPaginated(
      productId, 
      languageId, 
      page,
      response => {
        dispatch({
          type: GET_OPTION_VALUES_PAGE_RESPONSE,
          response: response,
          productId: productId,
          page: page,
          action: () => getProductOptionValuesPaginated(productId, languageId, page)
        })
      }
    )
  }
}

export const syncProductVariantMetafields = (product, language) => {  
  return (dispatch, getState) => {
    dispatch({
      type: SYNC_PRODUCT_VARIANT_METAFIELDS_PENDING
    })

    API.syncProductVariantMetafields(
      product,
      language,
      progress => {
        dispatch({
          type: SYNC_PRODUCT_VARIANT_METAFIELDS_PROGRESS,
          progress: progress
        })
      },
      response => {
        // Nothing refires a row sync after a switch, so the dropped one clears its own flag
        if(response && response.aborted === true) {
          dispatch({
            type: SYNC_PRODUCT_VARIANT_METAFIELDS_ABORTED
          })
          return;
        }

        dispatch({
          type: SYNC_PRODUCT_VARIANT_METAFIELDS_RESPONSE,
          response: response,
          stale: getState().shop.shop.edit_language !== language,
          action: () => syncProductVariantMetafields(product, language)
        }
      )
    })
  }
}

export const syncProductImages = (product, language) => {  
  return (dispatch, getState) => {
    dispatch({
      type: SYNC_PRODUCT_IMAGES_PENDING
    })

    API.syncProductImages(
      product,
      language,
      progress => {
        dispatch({
          type: SYNC_PRODUCT_IMAGES_PROGRESS,
          progress: progress
        })
      },
      response => {
        // Nothing refires a row sync after a switch, so the dropped one clears its own flag
        if(response && response.aborted === true) {
          dispatch({
            type: SYNC_PRODUCT_IMAGES_ABORTED
          })
          return;
        }

        dispatch({
          type: SYNC_PRODUCT_IMAGES_RESPONSE,
          response: response,
          stale: getState().shop.shop.edit_language !== language,
          product: product,
          action: () => syncProductImages(product, language)
        }
      )
    })
  }
}

export const createProductCustomContents = (product, language, items) => {  
  return dispatch => {
    dispatch({
      type: CREATE_PRODUCT_CUSTOM_CONTENTS_PENDING
    })

    API.createProductCustomContents(
      product,
      language,
      items,
      progress => {
        dispatch({
          type: CREATE_PRODUCT_CUSTOM_CONTENTS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: CREATE_PRODUCT_CUSTOM_CONTENTS_RESPONSE,
          response: response,
          items: items,
          action: () => createProductCustomContents(product, language, items)
        })
      })
  }
}

export const deleteProductCustomContent = (product, ids) => {
  return dispatch => {
    dispatch({
      type: DELETE_PRODUCT_CUSTOM_CONTENT_PENDING
    })

    API.deleteProductCustomContent(
      product,
      ids,
      progress => {
        dispatch({
          type: DELETE_PRODUCT_CUSTOM_CONTENT_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: DELETE_PRODUCT_CUSTOM_CONTENT_RESPONSE,
          response: response,
          action: () => deleteProductCustomContent(product, ids)
        })
      })
  }
}

export const clearExportUrls = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_EXPORT_URLS
    });
  }
}

/*
export const exportProducts = (language) => {
  return dispatch => {
    dispatch({
      type: EXPORT_PRODUCTS_PENDING
    })

    API.exportProducts(
      language,
      progress => {
        dispatch({
          type: EXPORT_PRODUCTS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: EXPORT_PRODUCTS_RESPONSE,
          response: response,
          action: () => exportProducts(language)
        }
      )
    })
  }
}
*/

export const exportProducts = (language, options) => {
  //console.log(options)
  return dispatch => {
    dispatch({
      type: EXPORT_PRODUCTS_PENDING
    })

    API.exportProducts(
      language,
      options,
      progress => {
        dispatch({
          type: EXPORT_PRODUCTS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: EXPORT_PRODUCTS_RESPONSE,
          response: response,
          options: options,
          action: () => exportProducts(language, options)
        }
      )
    })
  }
}

export const importProducts = (file, fileType, options, language) => {
  return dispatch => {
    dispatch({
      type: IMPORT_PRODUCTS_PENDING
    })

    API.importProducts(
      file,
      fileType,
      options,
      language,
      progress => {
        dispatch({
          type: IMPORT_PRODUCTS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: IMPORT_PRODUCTS_RESPONSE,
          response: response,
          options: options,
          action: () => importProducts(file, fileType, options, language)
        }
      )
    })
  }
}

export const exportProductMetafields = (language, callback) => {
  return dispatch => {
    dispatch({
      type: EXPORT_PRODUCTS_PENDING
    })

    API.exportProductMetafields(
      language,
      progress => {
        dispatch({
          type: EXPORT_PRODUCTS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: EXPORT_PRODUCTS_RESPONSE,
          response: response,
          action: () => exportProductMetafields(language)
        }
      )
      // the callback opens the download dialog, after a failure there is nothing to download
      if(response.success === true) {
        callback();
      }
    })
  }
}

export const importProductMetafields = (file, fileType, language) => {
  return dispatch => {
    dispatch({
      type: IMPORT_PRODUCTS_PENDING
    })

    API.importProductMetafields(
      file,
      fileType,
      language,
      progress => {
        dispatch({
          type: IMPORT_PRODUCTS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: IMPORT_PRODUCTS_RESPONSE,
          response: response,
          action: () => importProductMetafields(file, fileType, language)
        }
      )
    })
  }
}